import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getActiveSpecials } from '../../data/specials';
import { OfferSlider } from './OfferSlider';

const SpecialsSection = () => {
  if (getActiveSpecials().length === 0) return null;

  return (
    <section className="py-10 md:py-12 lg:py-16 bg-white" data-testid="home-specials-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 overflow-hidden sm:overflow-visible">
        <div className="text-center mb-8 md:mb-10">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider">Limited Time Offers</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-slate-900 mt-3 md:mt-4 mb-4 md:mb-6">
            Specials & Promotions
          </h2>
        </div>

        <OfferSlider />

        <div className="text-center mt-10">
          <Link to="/specials" className="btn-primary inline-flex items-center gap-2" data-testid="view-specials-btn">
            View All Specials <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SpecialsSection;
